export class Equipment {
  id:number;
  core_Id = null;
  location_Id: number;
  description: string;
  serial_Num: string;
  asset_Num: string;
  swl: string;
  manufacturer_Id: number;
  date_Of_Manufacture: string;
  category_Id: number;
  other_Details: string;
  expired = false;
  is_edit = false;
  selected = false;

}
